import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Finansal özet raporu çek
export const fetchFinancialSummary = createAsyncThunk(
  "reports/fetchFinancialSummary",
  async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });

    const res = await axios.get(
      `${BASE_URL}/reports/financial-summary?${params.toString()}`
    );
    return res.data;
  }
);

// Aylık grafik verisi çek
export const fetchMonthlyChart = createAsyncThunk(
  "reports/fetchMonthlyChart",
  async (year) => {
    const params = year ? `?year=${year}` : "";
    const res = await axios.get(`${BASE_URL}/reports/monthly-chart${params}`);
    return res.data;
  }
);

// Müşteri bazlı rapor çek
export const fetchCustomerReport = createAsyncThunk(
  "reports/fetchCustomerReport",
  async ({ customerId, startDate, endDate }) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const res = await axios.get(
      `${BASE_URL}/reports/customer/${customerId}?${params.toString()}`
    );
    return res.data;
  }
);

// PDF rapor oluştur ve indir
export const generatePDF = createAsyncThunk(
  "reports/generatePDF",
  async ({ customerId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/reports/generate-pdf`,
        { customerId, startDate, endDate },
        { responseType: "blob" }
      );

      // Blob'u indir
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `seans-raporu-${customerId}-${Date.now()}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "PDF oluşturulamadı"
      );
    }
  }
);

const reportSlice = createSlice({
  name: "reports",
  initialState: {
    financialSummary: null,
    monthlyChart: null,
    customerReport: null,
    loading: false,
    pdfLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearReports: (state) => {
      state.financialSummary = null;
      state.monthlyChart = null;
      state.customerReport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Financial Summary
      .addCase(fetchFinancialSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFinancialSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.financialSummary = action.payload;
      })
      .addCase(fetchFinancialSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch Monthly Chart
      .addCase(fetchMonthlyChart.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMonthlyChart.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyChart = action.payload;
      })
      .addCase(fetchMonthlyChart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch Customer Report
      .addCase(fetchCustomerReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerReport.fulfilled, (state, action) => {
        state.loading = false;
        state.customerReport = action.payload;
      })
      .addCase(fetchCustomerReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Generate PDF
      .addCase(generatePDF.pending, (state) => {
        state.pdfLoading = true;
        state.error = null;
      })
      .addCase(generatePDF.fulfilled, (state) => {
        state.pdfLoading = false;
      })
      .addCase(generatePDF.rejected, (state, action) => {
        state.pdfLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearReports } = reportSlice.actions;
export default reportSlice.reducer;
